import { render } from "./EditPromotion.vue?vue&type=template&id=18b6491b&ts=true"
import script from "./EditPromotion.vue?vue&type=script&lang=ts"
export * from "./EditPromotion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__